module.exports = __webpack_public_path__ + "img/face78.033440be.gif";